/**
 * @description Module document
 */

/* global ModuloTS */

(() => {
	// VARS
	const root = document.querySelector('[data-js-document]');

	const $ = {
		transcription: 'data-js-document-transcription',
		transcriptionToggle: 'data-js-document-toggle',
		actions: 'data-js-document-actions',
		colRight: 'data-js-document-col-right',
	};

	// FONCTIONS
	const toggleTranscription = () => {
		const dropTranscription = document.querySelectorAll(
			'[data-js-document-toggle]'
		);
		dropTranscription.forEach((element) => {
			const transcription = element.nextElementSibling;

			element.addEventListener('click', () => {
				element.classList.toggle('active');
				transcription.classList.toggle('active');
			});
		});
	};

	const moveActions = () => {
		if (window.screen.width <= 540) {
			const rootActions =
				document.querySelector(`[${$.actions}]`) || null;
			if (rootActions) {
				root.appendChild(rootActions);
			} else if (root.querySelector(`[${$.colRight}]`)) {
				root.appendChild(rootActions);
			}
		}
	};

	const borderedBox = () => {
		document
			.querySelectorAll('.rte-item.document.module.shadow')
			.forEach((el) => {
				const transcription = el.querySelector(
					'.document__transcription__btn'
				);

				if (transcription !== null && transcription !== undefined) {
					el.querySelector('.document__infos').classList.add(
						'document__infos__bordered'
					);
				}
			});
	};

	const h2Rm = () => {
		const allH2Desc = document.querySelectorAll(
			'.document__description h2'
		);
		const allH2Transc = document.querySelectorAll(
			'.document__transcription h2'
		);
		if (allH2Desc) {
			for (let i = 0; i < allH2Desc.length; i++) {
				allH2Desc[i].outerHTML =
					'<h4>' + allH2Desc[i].innerHTML + '</h4>';
			}
		}
		if (allH2Transc) {
			for (let i = 0; i < allH2Transc.length; i++) {
				allH2Transc[i].outerHTML =
					'<h4>' + allH2Transc[i].innerHTML + '</h4>';
			}
		}
	};

	// Resize
	if (root) {
		window.addEventListener('resize', () => {
			moveActions();
		});
	}

	const showMore = () => {
		const media = document.querySelectorAll('.media-content');
		media.forEach((el) => {
			if (media === null || media === undefined) {
				el.querySelector('[data-js-dropdown-toggle]').addEventListener(
					'click',
					() => {
						setTimeout(() => {
							const block = el.querySelector(
								'.media-content-transcription'
							);
							const p = el.querySelector(
								'.media-content-transcription p'
							);
							const btn = el.querySelector(
								'.media-content-transcription .btn'
							);

							if (
								block.classList.contains('active') &&
								p.offsetHeight > 57
							) {
								block.insertAdjacentHTML(
									'beforeend',
									'<button class="btn btn-primary">' +
										ModuloTS['Show more'] +
										'</button>'
								);
								p.classList.add(
									'document__transcription__show-more'
								);
								p.setAttribute('style', 'height: 57px;');
								block.setAttribute(
									'style',
									'margin-bottom: 50px'
								);

								const btnShowMore = el.querySelector(
									'.media-content-transcription .btn'
								);

								btnShowMore.addEventListener('click', () => {
									p.setAttribute(
										'style',
										'height: max-content;'
									);
								});
							} else {
								btn.remove();
								p.classList.remove(
									'document__transcription__show'
								);
								p.removeAttribute('style');
								block.removeAttribute('style');
							}
						});
					},
					500
				);
			}
		});
	};

	// GO 🚀
	const init = () => {
		if (root) {
			toggleTranscription();
			moveActions();
		}
		showMore();
		borderedBox();
		h2Rm();
	};

	init();
})();
